import { render, staticRenderFns } from "./modal-add-edit-reminder-note.vue?vue&type=template&id=278ee2d6&scoped=true&lang=pug"
import script from "./modal-add-edit-reminder-note.js?vue&type=script&lang=js&external"
export * from "./modal-add-edit-reminder-note.js?vue&type=script&lang=js&external"
import style0 from "./modal-add-edit-reminder-note.vue?vue&type=style&index=0&id=278ee2d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278ee2d6",
  null
  
)

export default component.exports